import Image from "../../assets/image";
import NewsBgColorsData from "../../js/NewsBgColorsData";
import {
  Animatespin,
  SearchbarCom,
  SidenavbarCom,
  LatestNewsCom,
  Pagination,
} from "../../components";
import Functions from "./index.function";
export default function DashBoardNews() {
  const {
    isLoading,
    newsData,
    handleNews,
    baseURL,
    localThumbnailImgurl,
    setCurrentPage,
    currentPage,
    total_pages,
    has_more_pages,
  } = Functions();

  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 scroll-container sm:h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5`}>
            <div className="flex flex-col relative w-full my-5 bg-[#1A1A1A] xs:px-1.5 xs:pt-14 xs:pb-5 sm:px-3 sm:pt-16 sm:pb-7 lg:pt-24 lg:pb-10 lg:px-5 rounded-lg">
              <div className="flex items-center justify-between">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-lg font-unboundedBold">
                  News
                </h1>
              </div>
              {isLoading === true ? (
                <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                  <Animatespin />
                </div>
              ) : (
                <>
                  {newsData?.news?.lenght === 0 ? (
                    <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full">
                      Data not available
                    </p>
                  ) : (
                    <div className="xs:py-5 sm:pt-7 lg:pt-10 xs:gap-y-3 sm:gap-y-4 lg:gap-y-5 xl:gap-y-6 grid xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
                      {newsData?.news?.map((value, index) => (
                        <div key={index}>
                          <LatestNewsCom
                            onClick={() => handleNews(value?.id)}
                            latestNewsthubmail={
                              value?.hero_image === null
                                ? Image.LatestNews_1
                                : `${baseURL}/${localThumbnailImgurl}/${value?.hero_image}`
                            }
                            latestNewsTitle={value?.news_title}
                            alt={value?.news_title}
                            bgcolor={
                              NewsBgColorsData[index % NewsBgColorsData?.length]
                                .newstheme
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
              {newsData?.total_records > 10 && (
                <div className="flex justify-end items-center pt-5">
                  <Pagination
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    total_pages={total_pages}
                    has_more_pages={has_more_pages}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
